import type { FlowContext, Step } from '@/types'

/**
 * Evaluates if a step should be rendered based on its condition
 *
 * @param step - The step to evaluate
 * @param ctx - Current flow context
 * @returns true if step should be rendered, false otherwise
 */
export function shouldRenderStep(step: Step, ctx: FlowContext): boolean {
  if (!step.condition) return true
  return step.condition(ctx)
}

/**
 * Executes a compute step, modifying the context
 *
 * @param step - The compute step to execute
 * @param ctx - Current flow context (will be mutated)
 */
export function executeStep(step: Step, ctx: FlowContext): void {
  if (step.type === 'compute' && step.run) {
    step.run(ctx)
  }
}

/**
 * Determines if a step should be visible in the UI
 *
 * @param step - The step to check
 * @returns true if step should be visible
 */
export function isVisibleStep(step: Step): boolean {
  return (
    step.type === 'message' ||
    step.type === 'input' ||
    step.type === 'choice' ||
    step.type === 'video'
  )
}
